import {Scroll} from '@/utils/scroll';

const FormMessage = {
  watch: {
    message(value) {
      if (value) {
        this.$nextTick(Scroll.toPageTop);
      }
    },
  },

  methods: {
    /**
     * Hide message.
     */
    hideMessage() {
      this.message = '';
      this.messageType = 'default';
    },

    /**
     * Display error message.
     * @param message
     */
    displayError(message) {
      this.messageType = 'error';
      this.message = message;
    },

    /**
     * Display success message.
     * @param message
     */
    displaySuccess(message) {
      this.messageType = 'success';
      this.message = message;
    },
  },
  data() {
    /**
     * using default message type so there are styles if no message type is provided
     */
    return {
      messageType: 'default',
      message: '',
    };
  },
};

export {FormMessage};
